import * as actionTypes from "../actions/actionTypes";
import BackendClient from "../../BackendClient";
import {put, takeLatest} from "redux-saga/effects";
import {druid} from "../actions/actionTypes";
import * as actions from '../actions';
import ExpiringLocalStorage from "../../utils/ExpiringLocalStorage";

export function* scanDocument(action) {
    const axios = BackendClient.getInstance();
    // let formattedFiles = formatFiles(action.files);
    try {
        let uploadForm = new FormData();
        Object.keys(action.files).forEach((attrName) => {
            uploadForm.append("files[]", action.files[attrName]);
        });

        uploadForm.append('paid', ExpiringLocalStorage.get('paid'))

        const response = yield axios({
            url: '/api/documents/scan',
            method: 'post',
            data: uploadForm
        });

        if (!response) {
            throw new Error(`[ERROR] DRUID SCAN response is empty!`);
        }

        if (!response.hasOwnProperty('result')) {
            throw new Error(`[ERROR] DRUID SCAN  response has no 'result' property`);
        }

        yield put(actions.scanComplete(response.result));
    } catch (error) {
        console.log(error);
        return;
    }
}

const formatFiles = (files) => {
    let formattedFiles = [];

    files.forEach((fileElement, index) => {
        // let fileElement = files[attribute];
        let file = {
            index: index,
            name: fileElement.name,
            size: fileElement.size,
            type: fileElement.type,
        };

        formattedFiles.push(file);
    });

    return formattedFiles;
};

export default function* watchDruidSaga() {
    yield takeLatest(druid.SCAN_DOCUMENT,scanDocument);
}